/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { MenuDto } from '../models/menu-dto';
import { menuGetMenuById$Json } from '../fn/menu/menu-get-menu-by-id-json';
import { MenuGetMenuById$Json$Params } from '../fn/menu/menu-get-menu-by-id-json';
import { menuGetMenuById$Plain } from '../fn/menu/menu-get-menu-by-id-plain';
import { MenuGetMenuById$Plain$Params } from '../fn/menu/menu-get-menu-by-id-plain';

@Injectable({ providedIn: 'root' })
export class MenuService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `menuGetMenuById()` */
  static readonly MenuGetMenuByIdPath = '/api/Menu/{menuId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menuGetMenuById$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  menuGetMenuById$Plain$Response(params: MenuGetMenuById$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuDto>> {
    return menuGetMenuById$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menuGetMenuById$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  menuGetMenuById$Plain(params: MenuGetMenuById$Plain$Params, context?: HttpContext): Observable<MenuDto> {
    return this.menuGetMenuById$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<MenuDto>): MenuDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menuGetMenuById$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  menuGetMenuById$Json$Response(params: MenuGetMenuById$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuDto>> {
    return menuGetMenuById$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menuGetMenuById$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  menuGetMenuById$Json(params: MenuGetMenuById$Json$Params, context?: HttpContext): Observable<MenuDto> {
    return this.menuGetMenuById$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<MenuDto>): MenuDto => r.body)
    );
  }

}
